/* tslint:disable:indent */
/**
 * Cette classe contient l'ensemble des codes des formulaires il faut que l'ordre soit identique à celui dans le fichier FormsEnum dans JAVA
 */
export enum FormsEnum {
  // divers
  DIVE_AN,
  DIVE_AT,
  DIVE_IN,
  DIVE_RE,
  // fnSimple
  SIMP_AN,
  SIMP_AT,
  SIMP_IN,
  SIMP_IC,
  SIMP_RE,
  // MAPA
  MAPA_AN,
  MAPA_AT,
  MAPA_IC,
  MAPA_IN,
  MAPA_RE,
  // AD
  FORM_AD,
  // EFORMS
  E_FORM_1,
  E_FORM_10,
  E_FORM_11,
  E_FORM_12,
  E_FORM_13,
  E_FORM_14,
  E_FORM_15,
  E_FORM_16,
  E_FORM_17,
  E_FORM_18,
  E_FORM_19,
  E_FORM_2,
  E_FORM_20,
  E_FORM_21,
  E_FORM_22,
  E_FORM_23,
  E_FORM_24,
  E_FORM_25,
  E_FORM_26,
  E_FORM_27,
  E_FORM_28,
  E_FORM_29,
  E_FORM_3,
  E_FORM_30,
  E_FORM_31,
  E_FORM_32,
  E_FORM_33,
  E_FORM_34,
  E_FORM_35,
  E_FORM_36,
  E_FORM_37,
  E_FORM_38,
  E_FORM_39,
  E_FORM_4,
  E_FORM_40,
  E_FORM_5,
  E_FORM_6,
  E_FORM_7,
  E_FORM_8,
  E_FORM_9,
  E_FORM_CEI,
  E_FORM_T01,
  E_FORM_T02,
  E_FORM_X01,
  E_FORM_X02,

  E_FORM
}

export class FormsMapper {

  public static getIntitule(forms: string) {
    const form = FormsEnum[forms];
    if (form?.toString().includes('E_FORM_')) {
      return "eform-not-editable.notice|name|"+form.split('_').pop();
    }
    switch (form) {
      case FormsEnum.FORM_AD: {
        return 'Formulaire adapté';
      }
      case FormsEnum.DIVE_AN: {
        return 'Avis divers d’annulation';
      }
      case FormsEnum.DIVE_AT: {
        return 'Avis divers d’attribution';
      }
      case FormsEnum.DIVE_IN: {
        return 'Avis  divers initial';
      }
      case FormsEnum.DIVE_RE: {
        return 'Avis divers rectificatif';
      }
      case FormsEnum.MAPA_AN: {
        return 'MAPA - Avis d’annulation';
      }
      case FormsEnum.MAPA_AT: {
        return 'MAPA - Avis d’attribution';
      }
      case FormsEnum.MAPA_IC: {
        return 'MAPA - Avis d’intention de conclure (renvoie vers le JOUE 15)';
      }
      case FormsEnum.MAPA_IN: {
        return ' MAPA - Avis de marché';
      }
      case FormsEnum.MAPA_RE: {
        return 'MAPA - Avis rectificatif';
      }
      case FormsEnum.SIMP_AN: {
        return 'Avis simplifié d’annulation';
      }
      case FormsEnum.SIMP_AT: {
        return 'Avis simplifié d’attribution';
      }
      case FormsEnum.SIMP_IC: {
        return 'Avis simplifié d’intention de conclure';
      }
      case FormsEnum.SIMP_IN: {
        return 'Avis simplifié initial';
      }
      case FormsEnum.SIMP_RE: {
        return 'Avis simplifié rectificatif';
      }
    }
  }
}
